<template>
  <div v-if="AreIdsShown">
    <img class="img-fluid" width="1500px" :src="userProfileCard1" />
  </div>
  <div :class="modalTheme" style="padding:9px;">
    <!-- <div :class="userStore.borderClass" style="padding-right: 5px; height: 35px">xxxxxxx</div> -->
    <!-- {{ modalTheme }} -->

    <b-card class="widgetFilterForm">
      <b-card-title style="background: transparent">
        <b-row style="background: transparent; padding: 0px 0px 0px 0px">
          <b-col cols="9" style="background: transparent; display: flex; align-items: center">
            <h3>{{ userSecurityGroupName }}</h3>
          </b-col>
          <b-col cols="3" style="background: transparent; display: flex; align-items: center"><LogOutButton /></b-col>
        </b-row>
      </b-card-title>

      <b-card-text>
        <b-row style="background: transparent; padding: 0px 0px 0px 0px">
          <b-col cols="4" style="background: transparent; padding: 0%; display: flex; align-items: center">
            <!-- <h3>ICON</h3> -->
            <span class="fa-stack fa-5x">
              <font-awesome-icon :icon="['fas', 'circle']" class="fa-stack-2x" :style="{ color: themeColor }"  />
              <font-awesome-icon :icon="['fas', 'user']" class="fa-stack-1x fa-inverse" />
              <span class="fa-stack-1x fa-inverse" style="display: flex; align-items: center; justify-content: center">{{ usersInitials }}</span>
              <!-- Replace with your initials and font style
              -->
            </span>
            <!-- <span class="fa-stack fa-2x">
            <font-awesome-icon class="fa-stack" icon="fa-solid fa-circle fa-stack-2x" style="color: rgba(111, 159, 94, 0.845)" />
            <font-awesome-icon class="fa-stack-1x fa-inverse" icon="fa-solid fa-bell fa-stack-1x" style="color: rgb(203, 221, 204)" />
            <span>NEW</span>
          </span> -->
          </b-col>
          <b-col cols="7" style="background: transparent; display: flex; align-items: center">
            <b-row no-gutters>
              <b-col class="text-left p-2 m-0">
                <h2 style="font-weight: bolder">{{ userStore._user.fullName }}</h2>
                <h5>{{ userStore._user.name }}</h5>
                <!-- Add security group display -->
                <div class="security-group-info">
                  <small class="text-muted">Security Group:</small>
                  <br />
                  <span class="security-group-name">{{ userSecurityGroupName || "Not assigned" }}</span>
                </div>
                <!-- <font-awesome-icon icon="fa-solid fa-user-plus" /> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!-- <h5>{{ userStore._user }}</h5> -->
      </b-card-text>
    </b-card>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import LogInButton from "@/modules/User/LogInButton.vue";
import LogOutButton from "@/modules/User/LogOutButton.vue";

// import imgBirthdayLOGO from "/bdparty-logo[2083].png";
import userProfileCard1 from "@/assets/images/userProfileCardMOCK.png";

const modalTheme = computed(() => userStore.bModalTheme);

// Map theme classes to their primary colors
const themeColor = computed(() => {
  const themeColorMap = {
    'generic-light-modal': '#123486',
    'generic-dark-modal': '#dcf1de',
    'generic-light-orange-modal': '#b85c00',
    'generic-dark-orange-modal': '#ffb366',
    'generic-light-yellow-modal': '#b59a00',
    'generic-dark-yellow-modal': '#ffe066',
    'generic-light-green-modal': '#0b7d3c',
    'generic-dark-green-modal': '#4de1a7',
    'generic-light-blue-modal': '#0a4d7d',
    'generic-dark-blue-modal': '#66bfff',
    'generic-light-red-modal': '#a10000',
    'generic-dark-red-modal': '#ffb3b3',
    'generic-light-white-modal': '#123486',
  };

  return themeColorMap[modalTheme.value] || '#123486'; // fallback color
});



// Computed property to get the security group
const userSecurityGroupName = computed(() => {
  return userStore.securityGroups?.find((group) => group.id === userStore.currentSecurityGroup)?.name || "Unknown Group";
});

// Computed property to get user initials from fullName
const usersInitials = computed(() => {
  const fullName = userStore._user?.fullName;
  if (!fullName) return "";

  const names = fullName.trim().split(" ");
  const firstInitial = names[0]?.charAt(0).toUpperCase() || "";
  const lastInitial = names[names.length - 1]?.charAt(0).toUpperCase() || "";

  return firstInitial + lastInitial;
});

const AreIdsShown = ref(false);

onMounted(() => {
// console.log("onMounted() :      UserProfile CARD  >>>>");
// console.log("User security group:", userSecurityGroupName.value);
  // console.log("Available user properties:", Object.keys(userStore._user || {}));

  // console.log("                                      Full user object:", userStore._user);
});
</script>

<style scoped>
/* Add your styles here */
</style>
